<script lang="ts">
    export let value: any
    export let locale = "de-DE"

    export let decimals = 2
    export let unit: string = null

    $: if (typeof value != "number") {
        if (value) {
            if (decimals) {
                value = parseFloat(value)
            } else {
                value = parseInt(value)
            }
        } else {
            value = null
        }
    }
</script>

{#if typeof value == "number"}
    {value.toLocaleString(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    })}
    {#if unit}
        {unit}
    {/if}
{/if}
